import setFilters from 'store/reducer-utils/setFilters'
import { currencyMap } from 'utils/formatMoney'
import prepareChartData from 'utils/prepareChartData'
import { updateObject } from 'utils/updateObject'
import { IS_APP_PRODUCT_GETUNIQ } from 'utils/constants/product'
import {
  DROP_TABLE_DATA,
  FETCH_CHART_START,
  FETCH_FAIL,
  FETCH_TABLE_START,
  MAIN_FILTERS_APPLY,
  RESET_FILTERS,
  SET_CHART,
  SET_CHART_TYPE,
  SET_FILTER,
  SET_TABLE,
  TOGGLE_METRIC_HIDDEN,
  UPDATE_ACCOUNT_BY_ID,
  UPDATE_ACCOUNTS,
  UPDATE_GROUP_BY_ID,
  UPDATE_GROUPS,
} from 'modules/Statistics/types'

const initialState = {
  groups: [],
  accounts: [],
  accountsLoaded: false,
  table: {
    loadFailed: false,
    loading: true,
    data: [],
    summary: {},
    pagination: {
      total: 0,
    },
  },
  chart: {
    loadFailed: false,
    loading: true,
    data: [],
    summary: {},
    chartType: 'Line',
    measure: {
      clicks: '',
      impressions: '',
      cost: IS_APP_PRODUCT_GETUNIQ ? currencyMap.rub : '',
      revenue: IS_APP_PRODUCT_GETUNIQ ? currencyMap.rub : '',
    },
    metrics: [
      { id: 'clicks', isActive: true },
      { id: 'impressions', isActive: true },
      { id: 'cost', isActive: true },
      { id: 'revenue', isActive: true, isHidden: true },
    ],
  },
  filters: null,
}

const setLoading = (state, { payload }) =>
  updateObject(state, {
    [payload]: {
      ...state[payload],
      loading: true,
    },
  })

const setStatisticsChart = (state, { payload }) => {
  const { data, summary } = payload
  const preparedChartData = prepareChartData(data, summary)

  return updateObject(state, {
    chart: {
      ...state.chart,
      data: preparedChartData.items,
      summary: preparedChartData.summary,
      loading: false,
      loadFailed: false,
    },
  })
}

const setStatisticsTable = (state, { payload }) =>
  updateObject(state, {
    table: {
      ...state.table,
      ...payload,
      data: [...state.table.data, ...payload.data],
      loading: false,
      loadFailed: false,
    },
  })

const fetchStatisticsFail = (state, { payload }) =>
  updateObject(state, {
    [payload]: {
      ...state[payload],
      loading: false,
      loadFailed: true,
    },
  })

const dropStatisticsTable = (state) =>
  updateObject(state, {
    table: {
      ...initialState.table,
      loading: true,
    },
  })

const setStatisticsFilters = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const applyFilters = (state, { payload }) => updateObject(state, { filters: payload })

const toggleMetricHidden = (state, action) =>
  updateObject(state, {
    chart: {
      ...state.chart,
      metrics: [
        ...state.chart.metrics.map((metric) => {
          const { id, isHidden = false } = metric

          if (id === action.payload.id) {
            return { ...metric, isHidden: !isHidden }
          }

          return metric
        }),
      ],
    },
  })

const setChartType = (state, { payload }) =>
  updateObject(state, {
    chart: { ...state.chart, chartType: payload.type },
  })

const updateGroupAccounts = (state, { payload }) => {
  const id = payload?.group?.id ?? payload?.id
  if (!id) return state

  const nextData = [...state.table.data]
  const groupPosition = nextData.findIndex(
    (group) => String(group?.id ?? group?.group?.id) === String(id),
  )

  if (groupPosition === -1) return state

  nextData[groupPosition] = payload

  return updateObject(state, {
    table: {
      ...state.table,
      data: nextData,
    },
  })
}

const updateGroups = (state, { payload }) =>
  updateObject(state, {
    groups: payload,
  })

const updateAccounts = (state, { payload }) =>
  updateObject(state, {
    accounts: payload,
    accountsLoaded: true,
  })

const updateAccountById = (state, { payload }) => {
  const { id, data } = payload
  const nextData = [...state.table.data]
  const accountPosition = nextData.findIndex((a) => a?.account?.id === id)

  if (accountPosition === -1) return state

  nextData[accountPosition].account = data

  return updateObject(state, {
    table: {
      ...state.table,
      data: nextData,
    },
  })
}
const resetStatisticsFilters = (state, action) => {
  return updateObject(state, { filters: action.payload })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case MAIN_FILTERS_APPLY:
      return applyFilters(state, action)
    case SET_FILTER:
      return setStatisticsFilters(state, action)
    case SET_CHART:
      return setStatisticsChart(state, action)
    case SET_TABLE:
      return setStatisticsTable(state, action)
    case FETCH_TABLE_START:
      return setLoading(state, action)
    case FETCH_CHART_START:
      return setLoading(state, action)
    case FETCH_FAIL:
      return fetchStatisticsFail(state, action)
    case DROP_TABLE_DATA:
      return dropStatisticsTable(state, action)
    case TOGGLE_METRIC_HIDDEN:
      return toggleMetricHidden(state, action)
    case SET_CHART_TYPE:
      return setChartType(state, action)
    case UPDATE_GROUP_BY_ID:
      return updateGroupAccounts(state, action)
    case UPDATE_GROUPS:
      return updateGroups(state, action)
    case UPDATE_ACCOUNTS:
      return updateAccounts(state, action)
    case UPDATE_ACCOUNT_BY_ID:
      return updateAccountById(state, action)
    case RESET_FILTERS:
      return resetStatisticsFilters(state, action)
    default:
      return state
  }
}

export default reducer
